import { PercentWithUnit } from 'components/shared/Percent/PercentWithUnit';
import { useUnderlyingContext } from 'hooks/useUnderlyingContext';
import { useCallback } from 'react';

interface Props {
  underlyingId: string;
  showWeight: boolean;
  weightValue?: Nullable<number>;

  isWeightInPercent?: boolean;
}
export function Data({ underlyingId, weightValue, isWeightInPercent = true, showWeight }: Props) {
  const { onUnderlyingWeightChanged, isLoading } = useUnderlyingContext();

  const onWeightBlurred = useCallback(
    (value: number | undefined) => {
      if (value === undefined || isLoading || underlyingId === undefined) {
        return;
      }
      onUnderlyingWeightChanged?.(underlyingId, value);
    },
    [isLoading, onUnderlyingWeightChanged, underlyingId],
  );

  if (!showWeight) {
    return null;
  }

  return (
    <td style={{ minWidth: 80, maxWidth: 80 }} className="align-middle">
      <PercentWithUnit
        data-e2e="underlying-weight"
        isDisabled={isLoading}
        onBlur={onWeightBlurred}
        placeholder="Weight"
        id="underlying-weight"
        title={weightValue?.toString()}
        value={weightValue}
        showUnit={isWeightInPercent}
      />
    </td>
  );
}
